import { motion } from "framer-motion";
import Lottie from "lottie-react";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import cartUpdate from "../animations/confirmed.json";
import { auth } from "../functions/firebase";

export default function SuccessCheckout() {

    const navigate = useNavigate()


    useEffect(() => {

        setTimeout(() => {
            navigate(`/auth-1/${auth.currentUser?.uid}/notifications`)
        }, 3000)

    }, [])

    return (
        <motion.div style={{
            width: "100vw",
            height: "100vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column"
        }}
            initial={{ y: 20, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
        >
            <div style={{ width: "100vw", aspectRatio: 1, overflow: "hidden" }}>
                <Lottie 
                    animationData={cartUpdate}
                    loop={false}
                />
            </div>
            <p>Thank you for shopping with us</p>
        </motion.div>
    )
}